import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PartnerPage } from './partner';

@NgModule({
  declarations: [
    PartnerPage,
  ],
  imports: [
    IonicPageModule.forChild(PartnerPage),
  ],
})
export class PartnerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/partner/partner.module.ts